import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/$accountId/threats/dashboard', search: true, params });
  },
});
